import { CombineRuleHistory, CreateCombineRuleHistoryInput } from '@/models/gen/graphql';
import { HandleErrorInput, handleError } from '@/utils/custom';
import createGraphApiHook, { CreateGraphApiHookHook } from '@/hooks/createGraphApiHook';

import { CreateCombineRuleHistoryBulkDocument } from '@/api/queries';
import { GraphApiMethod } from '@/api/core';
import graphApi from '@/api';

// Global Service Variables
const onError = (res: HandleErrorInput): void => handleError(res, { notification: { title: 'Create Combine Rule Setting' } });

type ServiceMethodPayload = { [key in keyof CreateCombineRuleHistoryInput]: any }[];
interface ServiceMethod {
  (payload: ServiceMethodPayload): Promise<CombineRuleHistory[]>;
}

// CreateCombineRuleHistoryBulk Service
export const { createCombineRuleHistoryBulk, useCreateCombineRuleHistoryBulk } = ((): {
  createCombineRuleHistoryBulk: ServiceMethod;
  useCreateCombineRuleHistoryBulk: CreateGraphApiHookHook<ServiceMethod>;
} => {
  const [mutate] = graphApi(CreateCombineRuleHistoryBulkDocument, {
    onError,
  }).map(
    (fn: GraphApiMethod<typeof CreateCombineRuleHistoryBulkDocument>): ServiceMethod =>
      async (payload: ServiceMethodPayload): Promise<CombineRuleHistory[]> => {
        const values: CreateCombineRuleHistoryInput[] = payload.map(
          (combineRule: CreateCombineRuleHistoryInput): CreateCombineRuleHistoryInput => ({ ...combineRule }) // Combine Rule does not have active, so can't set = 1
        );
        const res = await fn({ input: { values } });
        return res?.createCombineRuleHistoryBulk?.output?.map(({ node }: { node: CombineRuleHistory }): CombineRuleHistory => node) || [];
      }
  );

  const useService = createGraphApiHook(mutate, { bubble: true });
  return {
    createCombineRuleHistoryBulk: mutate,
    useCreateCombineRuleHistoryBulk: useService,
  };
})();
